import { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../constants/site';
import { resolveImg } from '../constants/siteImages';

const SiteImagesContext = createContext({});

export const SiteImagesProvider = ({ children }) => {
  const [map, setMap] = useState({});
  useEffect(() => {
    const load = () => axios.get(`${API}/site-images`).then((r) => setMap(r.data || {})).catch(() => {});
    load();
    window.addEventListener('dd-site-images-changed', load);
    return () => window.removeEventListener('dd-site-images-changed', load);
  }, []);
  return <SiteImagesContext.Provider value={map}>{children}</SiteImagesContext.Provider>;
};

// Returns the admin-overridden image for a slot key, or the built-in fallback
export const useSiteImage = (key, fallback) => {
  const map = useContext(SiteImagesContext);
  const v = map[key];
  return v ? resolveImg(v) : fallback;
};
